import { IStackTokens, mergeStyles, IStackItemStyles } from '@fluentui/react';

export const mainStackTokens: IStackTokens = {
  childrenGap: '0.25rem'
};
export const buttonsStackTokens: IStackTokens = {
  childrenGap: '0.75rem'
};
export const upperStackTokens: IStackTokens = {
  childrenGap: '1.5rem'
};
export const bottomStackTokens: IStackTokens = {
  childrenGap: '1.4375rem'
};
export const endCallContainerStyle = mergeStyles({
  width: '20.625rem'
});
export const endCallTitleStyle = mergeStyles({
  fontSize: '1.375rem',
  fontWeight: 600,
  textAlign: 'left',
  color: '#707070'
});
export const questionStyle = mergeStyles({
  fontSize: '18px',
  fontWeight: 600,
  textAlign: 'left',
  color: '#707070'
});
export const buttonStyle = (props: any) => mergeStyles({
  background: props.darkColor,
  textTransform: "none",
  height: '40px',
  // width: '218px',
  fontSize: '18px',
  color: '#fff',
  border: '0px',
  boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 0%), 0px 2px 2px 0px rgb(0 0 0 / 0%), 0px 1px 5px 0px rgb(0 0 0 / 0%)',
  '&:hover': {
    background: props.lightColor,
    color: '#fff',
    border: '0px',
  },
  // border: 'none !important',
  // padding: '6px 16px',
  // minWidth: '64px',
  // boxSizing: ' border-box',
  // transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  // fontFamily: 'Segoe UI',
  // fontWeight: '500',
  // lineHeight: 1.75,
  // borderRadius: '4px'
});
export const videoCameraIconStyle = mergeStyles({
  marginRight: '0.375rem',
  fontSize: '1.375rem'
});
export const bottomStackFooterStyle = mergeStyles({
  color: 'rgb(0,0,0)',
  fontSize: '0.875 rem'
});
export const stackItemStyles: IStackItemStyles = {
  root: {
    width: '100%',
    marginBottom: '20px'
  }
};
export const stackItemStyless: IStackItemStyles = {
  root: {
    width: '100%',
    marginBottom: '20px',
    background: '#ffffff',
    overflow: 'hidden',
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.50)',
    borderRadius: '5px',
    padding: '10px'
  }
};
export const fillstackItemStyles = mergeStyles({
  fontSize: '24px',
  fontWeight: 600,
  textAlign: 'center',
  color: '#707070'
});
export const stackBtnItemStyles: IStackItemStyles = {
  root: {
    width: '100%',
    textAlign: 'center',
    marginTop: '1.375rem !important'
  }
};
export const stackStyles: IStackItemStyles = {
  root: {
    marginTop: 100
  }
};
export const stackStyless: IStackItemStyles = {
  root: {
    marginTop: 20
  }
};
export const sstackStyles: IStackItemStyles = {
  root: {
    marginTop: 20,
    width: '100%'
  }
};
export const Selectlabelnamep1 = mergeStyles({
  color: '#007F80',
  fontSize: '18px',
  textAlign: 'left',
  width: '100%',
});

export const DescriptionSelecttext = mergeStyles({
  color: '#707070',
  width: '100%',
  fontSize: '18px',
  textAlign: 'left',
  marginTop: '12px',
  border: '1px solid #009C9D',
});

export const errormassagepanel = mergeStyles({
  color: '#D92E30',
  fontSize: '16px',
  textAlign: 'left',
  float: 'left'
});